import React, { useState } from "react";
import { ChartBar, CaretDown, CaretUp } from "@phosphor-icons/react";

// Game stats (Jack, 2026-11-04): a folding head-to-head table under the Elo
// pill. The better number in each row is gold. Turns are each player's own
// turn count; "–" means it never happened.
const STAT_ROWS = [
  { key: "words", label: "Words played", better: "high" },
  { key: "side", label: "Turns to reach their side", better: "low" },
  { key: "pow", label: "Turns to first POW", better: "low" },
  { key: "sealed", label: "Sealed off the other first", better: "low", sealed: true },
  { key: "base", label: "Tiles played against base", better: "high" },
];
const GOLD = "#f2b705";

export default function GameStats({ stats, oppUsername, colours }) {
  const [open, setOpen] = useState(false);
  const me = stats.me || {}, opp = stats.opp || {};
  const tint = (c, fallback) => (!c || c.value === "white" ? fallback : c.fill);
  const meCol = tint(colours?.me, "#f393a1");
  const oppCol = tint(colours?.opp, "#4FB0F0");
  const winner = (row) => {
    const a = me[row.key], b = opp[row.key];
    if (a == null && b == null) return null;
    if (a == null) return "opp";
    if (b == null) return "me";
    if (a === b) return null;
    return (row.better === "high" ? a > b : a < b) ? "me" : "opp";
  };
  const cell = (row, v, gold) => (
    <span className="text-center font-display font-extrabold text-sm leading-tight"
      style={gold ? { color: GOLD } : undefined}>
      {v == null ? "–" : row.sealed ? <>✓<small className="block text-[10px] font-semibold text-muted-foreground">turn {v}</small></> : v}
    </span>
  );
  return (
    <div className="mt-4 rounded-2xl border border-border bg-muted/30 overflow-hidden" data-testid="game-stats">
      <button type="button" onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-4 py-2.5 font-display font-bold text-sm"
        aria-expanded={open} data-testid="game-stats-toggle">
        <span className="flex items-center gap-2"><ChartBar size={18} weight="fill" /> Game stats</span>
        <span className="flex items-center gap-1 text-xs text-muted-foreground font-semibold">
          {open ? <>Hide <CaretUp size={12} weight="bold" /></> : <>Show <CaretDown size={12} weight="bold" /></>}
        </span>
      </button>
      {open && (
        <div className="px-3 pb-2" data-testid="game-stats-table">
          <div className="grid grid-cols-[1fr_64px_72px] items-center text-[11px] font-bold pb-1.5 border-b border-border">
            <span />
            <span className="text-center" style={{ color: meCol }}>You</span>
            <span className="text-center truncate" style={{ color: oppCol }}>{oppUsername}</span>
          </div>
          {STAT_ROWS.map((row) => {
            const w = winner(row);
            return (
              <div key={row.key} className="grid grid-cols-[1fr_64px_72px] items-center py-2 border-b border-border/60 last:border-0 text-[12.5px] text-left"
                data-testid={`game-stats-${row.key}`}>
                <span className="text-muted-foreground">{row.label}</span>
                {cell(row, me[row.key], w === "me")}
                {cell(row, opp[row.key], w === "opp")}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
